<div id="main" *ngIf="videoUrl">
  <div class="left">
    <ng-container *ngFor="let mediaId of mediaIds">
      <vg-player
        (onPlayerReady)="onPlayerReady($event, mediaId)"
        *ngIf="mediaId === activeMediaId"
      >
        <app-game-context
          *ngIf="showcaseStarted && isStageActive('time_on_ice')"
          [game]="game"
          [visible]="true"
          class="showcase-lineup-only"
        ></app-game-context>

        <app-video-object-tracks
          *ngIf="showcaseStarted"
          [game]="game"
          [frameRate]="frameRate"
          [frameNumber]="currentFrame + trackOffset"
          [onlyNumbers]="false"
          [videoWidth]="videoWidth"
          [videoHeight]="videoHeight"
          [showcaseStage]="showcaseStage"
          [showcaseStages]="activeStages"
        >
        </app-video-object-tracks>

        <img
          class="showcase-logo"
          src="/assets/49ing_logo_black.png"
          alt="49ing"
        />

        <div *ngIf="showcaseStarted" class="showcase-stage-label">
          <div
            *ngFor="let stage of labelStages; trackBy: trackByStageTitle"
            [@stageFade]="{
              value: '',
              params: { fadeInMs: labelFadeInMs, fadeOutMs: labelFadeOutMs }
            }"
            class="showcase-stage-content"
          >
            <div class="showcase-stage-title">
              {{ (labelStage ?? 0) + 1 }} {{ stage.title }}
            </div>
            <div class="showcase-stage-subtitle">
              {{ stage.subtitle }}
            </div>
          </div>
        </div>

        <div
          *ngIf="showcaseStarted && isStageActive('coordinate_mapping')"
          class="showcase-rink-overlay"
          [class.showcase-rink-swapped]="showcaseRinkSwapped"
        >
          <app-ice-rink
            [game]="game"
            [showPlayerPosition]="true"
            [pitch]="pitch"
          ></app-ice-rink>
        </div>

        <div *ngIf="configMenuVisible" class="showcase-config-menu">
          <h2>Configure Showcase</h2>
          <p class="hint">
            Use the video controls below to scrub to your desired start
            position, then click <strong>Start Showcase</strong>.
          </p>
          <div class="intro-row">
            <label for="intro-title-input">Intro title</label>
            <input
              id="intro-title-input"
              type="text"
              maxlength="40"
              [(ngModel)]="introTitle"
            />
          </div>
          <div class="intro-row">
            <label for="pitch-select">Pitch</label>
            <select id="pitch-select" [(ngModel)]="pitch">
              <option
                *ngFor="let option of pitchOptions"
                [ngValue]="option.pitch"
                >{{ option.label }}</option
              >
            </select>
          </div>
          <div class="intro-row">
            <label for="video-time-input">Video time</label>
            <input
              id="video-time-input"
              type="text"
              placeholder="hh:mm:ss"
              [(ngModel)]="videoTimeInput"
              (focus)="onVideoTimeFocus()"
              (blur)="onVideoTimeBlur()"
              (keydown.enter)="applyVideoTime(); $event.preventDefault()"
            />
          </div>
          <div class="stage-rows">
            <div
              *ngFor="let stage of stages; let i = index"
              class="stage-row"
              [class.stage-row-disabled]="!stage.enabled"
            >
              <input
                type="checkbox"
                class="stage-row-enabled"
                [(ngModel)]="stage.enabled"
              />
              <div class="stage-row-label">
                <div class="stage-row-title">
                  <ng-container *ngIf="stage.enabled"
                    >{{ activeStageNumber(stage) }} </ng-container
                  >{{ stage.title }}
                </div>
                <div class="stage-row-subtitle">{{ stage.subtitle }}</div>
              </div>
              <input
                type="number"
                min="1"
                max="120"
                [disabled]="!stage.enabled"
                [(ngModel)]="stage.durationInSeconds"
              />
              <span class="stage-row-unit">seconds</span>
            </div>
          </div>
          <div
            class="transition-accordion"
            [class.expanded]="transitionsExpanded"
          >
            <button
              type="button"
              class="transition-accordion-header"
              (click)="transitionsExpanded = !transitionsExpanded"
              [attr.aria-expanded]="transitionsExpanded"
            >
              <span class="transition-accordion-chevron">&rsaquo;</span>
              <span>Label transitions</span>
            </button>
            <div class="transition-rows" *ngIf="transitionsExpanded">
              <div class="intro-row">
                <label for="fade-in-input">Fade in</label>
                <input
                  id="fade-in-input"
                  type="number"
                  min="0"
                  max="60"
                  step="0.5"
                  [(ngModel)]="labelFadeInSeconds"
                />
                <span class="stage-row-unit">seconds</span>
              </div>
              <div class="intro-row">
                <label for="hold-input">Hold</label>
                <input
                  id="hold-input"
                  type="number"
                  min="0"
                  max="60"
                  step="0.5"
                  [(ngModel)]="labelHoldSeconds"
                />
                <span class="stage-row-unit">seconds</span>
              </div>
              <div class="intro-row">
                <label for="fade-out-input">Fade out</label>
                <input
                  id="fade-out-input"
                  type="number"
                  min="0"
                  max="60"
                  step="0.5"
                  [(ngModel)]="labelFadeOutSeconds"
                />
                <span class="stage-row-unit">seconds</span>
              </div>
            </div>
          </div>
          <div class="actions">
            <div class="total-duration">
              Total: <strong>{{ totalShowcaseDuration }}</strong>
            </div>
            <button class="start-btn" (click)="startShowcase()">
              Start Showcase
            </button>
          </div>
        </div>

        <div
          *ngIf="showcaseIntro"
          class="showcase-intro-card"
          [style.animationDuration.s]="INTRO_DURATION_SECONDS"
        >
          <img src="/assets/49ing_logo_white.png" alt="49ing" />
          <div class="intro-card-text">{{ introTitle }}</div>
        </div>

        <div *ngIf="showcaseComplete" class="showcase-end-card">
          <img src="/assets/49ing_logo_white.png" alt="49ing" />
        </div>

        <vg-controls *ngIf="!showcaseStarted">
          <vg-play-pause></vg-play-pause>
          <vg-playback-button
            [playbackValues]="['0.25', '0.5', '1.0', '2.0', '4.0']"
          ></vg-playback-button>
          <vg-time-display
            vgProperty="current"
            vgFormat="hh:mm:ss"
          ></vg-time-display>
          <vg-scrub-bar>
            <vg-scrub-bar-current-time></vg-scrub-bar-current-time>
          </vg-scrub-bar>
          <vg-time-display
            vgProperty="left"
            vgFormat="hh:mm:ss"
          ></vg-time-display>
          <vg-mute></vg-mute>
          <vg-volume></vg-volume>
          <vg-fullscreen></vg-fullscreen>
        </vg-controls>

        <video
          *ngIf="mediaId && mediaId.startsWith('video-vod-') && isMP4"
          [vgMedia]="mediaVOD"
          #mediaVOD
          type="video/mp4"
          [id]="mediaId"
          preload="auto"
          autoplay
          [src]="videoUrl"
        ></video>
        <video
          *ngIf="mediaId && mediaId.startsWith('video-hls-') && isHLS"
          [vgMedia]="mediaHLS"
          #mediaHLS
          [id]="mediaId"
          preload="auto"
          autoplay
          [vgHls]="videoUrl"
          [config]="hlsConfig"
        ></video>
      </vg-player>
    </ng-container>
  </div>
</div>
